{#if twitterHandle || facebookHandle}

  <div class="tabs is-fullwidth">
    <ul>

      {#if facebookHandle}
        <li class:is-active={activeSocialTab === "facebook"}>
          <a on:click={()=> activeSocialTab = 'facebook'}
            ><span class="icon">
              <i class="mdi mdi-facebook" />
            </span>Facebook</a
          >
        </li>
      {/if}

      {#if twitterHandle}
        <li class:is-active={activeSocialTab === "twitter"}>
          <a on:click={()=> activeSocialTab = 'twitter'}
            ><span class="icon">
              <i class="mdi mdi-twitter" />
            </span> Twitter</a
          >
        </li>
      {/if}

    </ul>
  </div>

  {#if activeSocialTab === "facebook"}
    <div style="height:100%;overflow:hidden;">
      <FacebookTimeline name={charity.name} handle={facebookHandle} />
    </div>
  {/if}

  {#if activeSocialTab === "twitter"}
    <div style="height:100%;overflow:hidden;">
      <TwitterTimeline name={charity.name} handle={twitterHandle} />
    </div>
  {/if}

{/if}

<script lang="ts">
  export let charity: Charity_v2;
  import TwitterTimeline from "./TwitterTimeline.svelte";
  import FacebookTimeline from "./FacebookTimeline.svelte";

  let twitterSocial = charity.contact.social?.find(
    (el) => el.platform == "twitter"
  );

  let facebookSocial = charity.contact.social?.find(
    (el) => el.platform == "facebook"
  );

  let twitterHandle = twitterSocial ? twitterSocial.handle : undefined;
  let facebookHandle = facebookSocial ? facebookSocial.handle : undefined;


  let activeSocialTab =
    facebookHandle? "facebook" : 
    twitterHandle ? "twitter" :
    undefined;
</script>
